import { render, staticRenderFns } from "./SurveyQuestionComment.vue?vue&type=template&id=931e8b0c"
import script from "./SurveyQuestionComment.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports